import React from 'react'
import { CloseAlt } from '@ticketswap/comets'
import styled from '@emotion/styled'
import {
  useDialog,
  DialogWindow,
  DialogHeader,
  DialogAdornment,
  DialogBody,
  Image,
  Text,
  space,
} from '@ticketswap/solar'
import useLocalStorage from '~/hooks/useLocalStorage'
import imageSrc from './mobile-screen.jpg'
import AppStoreBadges from '../AppStoreBadges'
import Notificaion from '../AppsAdoptionNotification'

const ImageContainer = styled.div`
  position: relative;
  display: block;
`

const StyledNotification = styled(Notificaion)`
  position: absolute;
  bottom: ${space[32]};
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
`

const StyledText = styled(Text)`
  text-align: center;
`

const StyledAppStoreBadges = styled(AppStoreBadges)`
  margin-top: ${space[16]};
  justify-content: center;
  text-align: center;
`

function AppsAdoptionDialog({ t, event, ...props }) {
  const [impressions, setImpressions] = useLocalStorage(
    'apps_adoption_dialog_impressions',
    0
  )
  const { show, hide, getWindowProps } = useDialog({
    onExited: () => {
      return requestAnimationFrame(() => setImpressions(impressions + 1))
    },
  })

  if (parseInt(impressions) > 0) {
    return props.children({ show })
  }

  return (
    <>
      {props.children({ show })}
      <DialogWindow {...getWindowProps()}>
        <DialogHeader>
          {t('event-eventtype:appsAdoption.dialog.title')}
          <DialogAdornment right>
            <button onClick={hide}>
              <CloseAlt size={24} />
            </button>
          </DialogAdornment>
        </DialogHeader>
        <ImageContainer>
          <Image src={imageSrc} />
          <StyledNotification t={t} eventName={event?.name} />
        </ImageContainer>
        <DialogBody>
          <StyledText as="p">
            {event?.isPopular && (
              <strong>
                {t('event-eventtype:appsAdoption.dialog.highDemand', {
                  eventName: event?.name,
                })}{' '}
              </strong>
            )}
            {t('event-eventtype:appsAdoption.dialog.text')}
          </StyledText>
          <StyledAppStoreBadges trackingContext="ALERTS_TOGGLE_ADOPTION_DIALOG" />
        </DialogBody>
      </DialogWindow>
    </>
  )
}

export default AppsAdoptionDialog
